import React, { useState, useEffect } from "react";
import Accordion from "./HierarchyAccordion";
import {
  fetchDepartment,
  getEmailSuggestions,
  hierarchyData,
  removeUser,
  submitUser,
} from "../../utils/API/TicketAPI";
import { useToken } from "../../utils/TokenContext";
import DeleteIcon from "../../assests/img/delete.svg";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import UserIcon from "./img/user-icon.svg";
import EmailIcon from "./img/email-icon.svg";
import TelePhoneIcon from "./img/telephone-icon.svg";
import CityLeadIcon from "./img/city-lead-icon.svg";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import { handleLogOut } from "../../utils/ClearCache";

function HierarchyManagement() {
  const [activeTabTicket, setActiveTabTicket] = useState("open");

  const [data, setData] = useState([]);
  // const { token } = useToken();
  const [showModal, setShowModal] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [emailSuggestions, setEmailSuggestions] = useState([]);
  const [selectedEmailSuggestion, setSelectedEmailSuggestion] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [fieldsEnabled, setFieldsEnabled] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(true);
  const editAccess = localStorage.getItem('editAccess');
  const hasAssigneeGroupp = editAccess && editAccess.includes('User Manager');
   const [departmentOptions, setDepartmentOptions] = useState([]);
   const [prevInput, setPrevInput] = useState("");

  //  const [isValidToken, setIsValidToken] = useState(true);
  const showToast = (message) => {
    toast.error(message);
  };

  const handleAddUserClick = (location, level, group) => {
    setShowModal(true);
    setSelectedLocation(location.locationId);
    setSelectedLevel(level);
    setSelectedDepartment(group._id);
    // Reset form values
    setEmailInput("");
    setEmailSuggestions([]);
    setSelectedEmailSuggestion(null);
    setFieldsEnabled(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // Reset form values
    setEmailInput("");
    setEmailSuggestions([]);
    setSelectedEmailSuggestion(null);
    setFieldsEnabled(false);
  };

  const handleCloseModalRemove = () => {
    setShowRemoveModal(false);
  };

  const handelTicketTab = (tab) => {
    setActiveTabTicket(tab);
    localStorage.setItem("activeTab", tab);
  };

  const handleDeleteUser = (user, group) => {
    setSelectedEmailSuggestion(user);
    setShowRemoveModal(true);
    setSelectedDepartment(group._id);
  };

  const hierarchyResult = async () => {
    try {
      const response = await hierarchyData();
      if (response?.statusValue === 200) {
        const newResults = response.data;
        setData(newResults);
      } else {
        console.log(response,"sdshgdhsgdhsghd")
        toast.error(response?.data?.message);
      }
    } catch (error) {
      showToast(
        `Error fetching hierarchy results: ${error?.response?.data?.error?.message}`
      );
      
    }
  };

  useEffect(() => {
    hierarchyResult();
  }, []);

  const handleEmailInputChange = async (event) => {
    const value = event.target.value;
    setEmailInput(value);
    if (emailInput) {
      setEmailSuggestions([]);
      setSelectedEmailSuggestion(null);
      setFieldsEnabled(false);
    }

    if (value.length < prevInput.length) {
      setEmailSuggestions([]);
      setSelectedEmailSuggestion(null);
      setFieldsEnabled(false);
      setPasswordVisible(false);
      setEmailError(null);
      setPrevInput(value); // Update previous input
      return;
    }
  
    setPrevInput(value); 
    // Check if the email format is correct
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(value) || !emailInput) {
      setEmailError("Invalid email format");
    } else {
      setEmailError(null);
    }

    try {
      const response = await getEmailSuggestions( value);
      if(response.statusValue === 200){
        setEmailSuggestions(response.data);
        if (response.data.length > 0) {
          setFieldsEnabled(false);
          setPasswordVisible(false);
        } else {
          setFieldsEnabled(true);
          setPasswordVisible(true);
        }
      } else{
          setEmailSuggestions([]);
      }
     
    } catch (error) {
      showToast(`Error fetching email suggestions: ${error.message}`);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSelectedEmailSuggestion(suggestion);
    setEmailInput(suggestion.email);
    setEmailSuggestions(emailSuggestions.filter((s) => s.id !== suggestion.id));
    setEmailError(null);
    setFieldsEnabled(false);
  };

  const handleSubmit = async () => {
    try {
      const response = await submitUser(
        [selectedLocation],
        selectedDepartment,
        selectedEmailSuggestion.name,
        emailInput,
        selectedEmailSuggestion.phone,
        selectedLevel,
        selectedEmailSuggestion.role,
        selectedEmailSuggestion.region,
        selectedEmailSuggestion.password,
      );
      if (response?.statusValue === 200) {
        toast.success(response?.message);
        hierarchyResult();
        setShowModal(false);
      } else {
        toast.error(response?.data);
        setShowModal(false);
      }
    } catch (error) {
      showToast(
        `Error fetching hierarchy results: ${error?.response?.data?.error?.message}`
      );
    }
  };

  const handleRemoveUser = async () => {
    try {
      const response = await removeUser(
        selectedDepartment,
        selectedEmailSuggestion._id,
      );
      if (response?.statusValue === 200) {
        toast.success("Data Removed Successfully");
        hierarchyResult();
        setShowRemoveModal(false);
      } else {
        toast.error(response?.message);
        setShowRemoveModal(false);
      }
    } catch (error) {
      showToast(
        `Error fetching hierarchy results: ${error?.response?.data?.error?.message}`
      );
    }
  };

  const fetchDepartmentOptions = async() => {
    try {
      const response = await fetchDepartment();
      if (response.data.statusValue === 200) {
        const departments = response.data.data.sort((a, b) =>
          a.label.localeCompare(b.label)
        ).map((dept) => ({
          label: dept.label,
          value: dept.value,
        }));
 
       setDepartmentOptions(departments)
      } else {
        setDepartmentOptions([]);
      }
    } catch (error) {
      console.error("Error fetching department names", error);
    }
  }
 
  useEffect(() => {
  
    fetchDepartmentOptions();
 
  }, []);

  return (
    <>
      {" "}
      <Header />
      <div className="wrapper d-flex">
        <Sidebar
          activeTab={activeTabTicket}
          handleTabClick={handelTicketTab}
          locationData={[]}
          selectedLocation={""}
        />
      </div>
      <section className="MainContent">
        <div className="Page Hierarchy_pageApp">
          <div className="PageTitle">
            <h2>Hierarchy Levels</h2>
          </div>

          <div className="PageContent">
            {/* Start Hierarchy Structure */}
            {data.map((location) => (
              <Accordion
                key={location.locationId}
                title={location.locationName}
              >
                {location.assigneeGroups.map((group) => (
                  <Accordion
                    key={group._id}
                    title={
                      departmentOptions.find(dept => dept.value === group.groupType)?.label || ""
                    }
                  >
                    {["l1", "l2", "l3", "l4", "l5"]?.map((level) => (
                      <Accordion
                        key={level}
                        title={
                          level === "l1"
                            ? "Level 1"
                            : level === "l2"
                            ? "Level 2"
                            : level === "l3"
                            ? "Level 3"
                            : level === "l4"
                            ? "Level 4"
                            : level === "l5"
                            ? "Level 5"
                            : ""
                        }
                      >
                        <div className="User_Header">
                      
                          {hasAssigneeGroupp? (
                            <a
                              className="addUser cursor-pointer"
                              onClick={() =>
                                handleAddUserClick(location, level, group)
                              }
                            >
                              + Add User
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                        {group[level]?.map((user, index) => (
                          <Accordion key={user._id} title={`User ${index + 1}`}>
                            <div className="user-box" key={user._id}>
                              <div className="UsrDtl_row">
                                <img src={UserIcon} alt="" />
                                <div>Name: {user.name}</div>
                              </div>
                              <div className="UsrDtl_row">
                                <img src={EmailIcon} alt="" />
                                <div>Email: {user.email}</div>
                              </div>
                              <div className="UsrDtl_row">
                                <img src={TelePhoneIcon} alt="" />
                                <div>Phone: {user.phone}</div>
                              </div>
                              <div className="UsrDtl_row">
                                <img src={CityLeadIcon} alt="" />
                                <div>
                                  Role: {user.role.length > 0 ? user.role : " "}{" "}
                                </div>
                              </div>
                              <div className="delete-icon cursor-pointer">
                                {hasAssigneeGroupp ? (
                                  <img
                                    src={DeleteIcon}
                                    alt=""
                                    onClick={() =>
                                      handleDeleteUser(user, group)
                                    }
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </Accordion>
                        ))}

                        <></>
                      </Accordion>
                    ))}
                  </Accordion>
                ))}
              </Accordion>
            ))}
            {/* End Hierarchy Structure */}
          </div>

          {/* Start Add user modal */}
          <Modal
            show={showModal}
            onHide={handleCloseModal}
            size="lg"
            dialogClassName="modal-90w ChangeStatusModal"
            centered
            backdrop="static"
            keyboard={false}
          >
            <Modal.Body>
              <div className="AddUserHead">
                <h3>
                  <span className="text-danger">*</span> Please fill following
                  information
                </h3>
                <a
                  type="button"
                  className="AddUser_Close btn-close"
                  aria-label="Close"
                  onClick={handleCloseModal}
                >
                  &nbsp;
                </a>
              </div>
              <div className="AddUserFleds">
                <div className="AddUserRow">
                  <label>Enter Email Id</label>
                  <input
                    className="form-control"
                    type="email"
                    placeholder="Enter an email id"
                    value={emailInput}
                    onChange={handleEmailInputChange}
                  />
                  {emailError && (
                    <div style={{ color: "red", marginBottom: "10px" }}>
                      {emailError}
                    </div>
                  )}
                  <div className="EmailSuggestion_Box">
                    {emailSuggestions.map((suggestion) => (
                      <div
                        className="EmailSuggestion_chip"
                        key={suggestion.id}
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        {suggestion.email}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="AddUserRow">
                  <label>Name</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter a name"
                    value={
                      selectedEmailSuggestion
                        ? selectedEmailSuggestion.name
                        : ""
                    }
                    onChange={(e) =>
                      setSelectedEmailSuggestion({
                        ...selectedEmailSuggestion,
                        name: e.target.value,
                      })
                    }
                    disabled={!fieldsEnabled}
                  />
                </div>
                <div className="AddUserRow">
                  <label>Phone Number</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter phone number"
                    value={
                      selectedEmailSuggestion
                        ? selectedEmailSuggestion.phone
                        : ""
                    }
                    onChange={(e) =>
                      setSelectedEmailSuggestion({
                        ...selectedEmailSuggestion,
                        phone: e.target.value,
                      })
                    }
                    onKeyPress={(e) => {
                      if (!/\d/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    disabled={!fieldsEnabled}
                  />
                </div>
                <div className="AddUserRow">
                  <label>Role (Optional)</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter role"
                    value={
                      selectedEmailSuggestion
                        ? selectedEmailSuggestion.role
                        : ""
                    }
                    onChange={(e) =>
                      setSelectedEmailSuggestion({
                        ...selectedEmailSuggestion,
                        role: e.target.value,
                      })
                    }
                    disabled={!fieldsEnabled}
                  />
                </div>
                <div className="AddUserRow">
                  <label>Level</label>
                  <select
                    className="form-control"
                    value={selectedLevel}
                    onChange={(e) => setSelectedLevel(e.target.value)}
                    disabled
                  >
                    <option value="l1">Level 1</option>
                    <option value="l2">Level 2</option>
                    <option value="l3">Level 3</option>
                    <option value="l4">Level 4</option>
                    <option value="l5">Level 5</option>
                  </select>
                </div>
                <div className="AddUserRow">
                  <label>Department</label>
                  <select
                    className="form-control"
                    value={selectedDepartment}
                    onChange={(e) => setSelectedDepartment(e.target.value)}
                    disabled
                  >
                    {data.map((location) =>
                      location.assigneeGroups.map((group) => (
                        <option key={group._id} value={group._id}>
                           {departmentOptions.find(dept => dept.value === group.groupType)?.label || ""}
                        </option>
                      ))
                    )}
                  </select>
                </div>

                <div className="AddUserRow">
                  <label>Location</label>
                  <select
                    className="form-control"
                    value={selectedLocation}
                    onChange={(e) => setSelectedLocation(e.target.value)}
                    disabled
                  >
                    {data.map((location) => (
                      <option
                        key={location.locationId}
                        value={location.locationId}
                      >
                        {location.locationName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="AddUserRow">
                  <label>Region (Optional)</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Select region"
                    value={
                      selectedEmailSuggestion
                        ? selectedEmailSuggestion.region
                        : ""
                    }
                    onChange={(e) =>
                      setSelectedEmailSuggestion({
                        ...selectedEmailSuggestion,
                        region: e.target.value,
                      })
                    }
                    disabled={!fieldsEnabled}
                  />
                </div>

                {/* <div className="AddUserRow">
      <label>Set Password</label>
      <input className="form-control" type="password" placeholder="Set password"
        onChange={(e) => setSelectedEmailSuggestion({ ...selectedEmailSuggestion, password: e.target.value })} />
    </div> */}

                <div
                  className="AddUserRow"
                  style={{ display: passwordVisible ? "block" : "none" }}
                >
                  <label>Set Password</label>
                  <div className="input-group">
                    <input
                      className="form-control"
                      type={showPassword ? "text" : "password"}
                      placeholder="Set password"
                      disabled={!fieldsEnabled}
                      onChange={(e) =>
                        setSelectedEmailSuggestion({
                          ...selectedEmailSuggestion,
                          password: e.target.value,
                        })
                      }
                    />
                    <span
                      className="input-group-text showPass"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i
                        className={
                          showPassword ? "fa fa-eye-slash" : "fa fa-eye"
                        }
                      />
                    </span>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="ModalCTA">
                <button
                  className="btn btn-dark ModalCTA_Dark"
                  onClick={handleSubmit}
                  disabled={
                    !selectedEmailSuggestion ||
                    !selectedEmailSuggestion.name ||
                    !emailInput ||
                    emailError !== null
                  }
                >
                  Submit
                </button>
              </div>
            </Modal.Footer>
          </Modal>
          {/* End Add user modal */}

          {/* Start Remove user modal */}
          <Modal
            show={showRemoveModal}
            onHide={handleCloseModalRemove}
            centered
            backdrop="static"
            keyboard={false}
          >
            <Modal.Body>Are you sure you want to remove this user?</Modal.Body>
            <Modal.Footer>
              <div className="ModalCTA">
                <button
                  className="btn btn-dark ModalCTA_Remove"
                  onClick={handleCloseModalRemove}
                >
                  Cancel
                </button>
                &nbsp;
                <button
                  className="btn btn-dark ModalCTA_Remove"
                  onClick={handleRemoveUser}
                >
                  Yes, remove
                </button>
              </div>
            </Modal.Footer>
          </Modal>

          {/* End Remove user modal */}
        </div>
      </section>
    </>
  );
}

export default HierarchyManagement;
